import { render, staticRenderFns } from "./CommunicationAdd.vue?vue&type=template&id=b6838e28&scoped=true&"
import script from "./CommunicationAdd.vue?vue&type=script&lang=js&"
export * from "./CommunicationAdd.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationAdd.vue?vue&type=style&index=0&id=b6838e28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6838e28",
  null
  
)

export default component.exports